// extracted by mini-css-extract-plugin
export var card = "_o8-0";
export var content = "_o8-2";
export var icon = "_o8-1";